import { OPEN_PLAYER_POPUP, CLOSE_PLAYER_POPUP } from "../actions";
import { Profile } from "../types";

type Profiles = {
	[key: string]: Profile;
};

export const initialState = {
	show: false,
	selectedProfileId: null,
	profiles: {} as Profiles,
	showChallengeButton: false,
	challengeButtonParams: {},
	contextParams: {},
};

export type PlayerModalState = typeof initialState;

export default function (state = initialState, action) {
	switch (action.type) {
		case OPEN_PLAYER_POPUP: {
			const profile = action.profile as Profile;
			let profiles = state.profiles;
			profiles[profile.userId] = profile;

			return {
				show: true,
				profiles,
				selectedProfileId: profile.userId,
				showChallengeButton: action.showChallengeButton,
				challengeButtonParams: action.challengeButtonParams,
				contextParams: action.contextParams,
			};
		}

		case CLOSE_PLAYER_POPUP: {
			return { ...state, show: false };
		}

		case "@@router/LOCATION_CHANGE": {
			return { ...state, show: false, selectedProfileId: null };
		}

		default:
			return state;
	}
}
